import React, { useState, useEffect } from 'react';
import "../../Assets/Styles/Schedule/schedule.scss";
import axios from 'axios';
import moment from 'moment';
import Availability from './Availability';
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import Navbar from "../Navbar";
import { useNepaliWeekDates } from '../../Hooks/useNepaliDates';

const Schedule = () => {
  const [banquetLunchHallOne, setBanquetLunchHallOne] = useState([]);
  const [banquetLunchHallTwo, setBanquetLunchHallTwo] = useState([]);
  const [banquetDinnerHallOne, setBanquetDinnerHallOne] = useState([]);
  const [banquetDinnerHallTwo, setBanquetDinnerHallTwo] = useState([]);

  const [inquiryLunchHallOne, setInquiryLunchHallOne] = useState([]);
  const [inquiryLunchHallTwo, setInquiryLunchHallTwo] = useState([]);
  const [inquiryDinnerHallOne, setInquiryDinnerHallOne] = useState([]);
  const [inquiryDinnerHallTwo, setInquiryDinnerHallTwo] = useState([]);

  const [initialLoad, setInitialLoad] = useState(true);
  const [dateRange, setDateRange] = useState({
    start: moment().format('YYYY-MM-DD'),
    end: moment().add(6, 'days').format('YYYY-MM-DD')
  });
  const [token, setToken] = useState("");

  const { englishDates: displayDates, nepaliDates } = useNepaliWeekDates(dateRange.start);

  let baseUrl = process.env.REACT_APP_BASE_URL;
  let navigate = useNavigate();

  useEffect(() => {
    const tokenCheck = localStorage.getItem("tokens");
    if (!tokenCheck) {
      navigate('/');
    } else {
      setToken(tokenCheck);
    }
  }, [navigate]);
  useEffect(() => {
    if (!token) return;

    const loadScheduleData = async () => {
      try {
        const response = await axios.post(`${baseUrl}/schedule`, {
          startDate: dateRange.start,
          endDate: dateRange.end,
          token: token
        });

        const { banquet = {}, inquiry = {} } = response.data;

        if (banquet.lunch && banquet.lunch.length > 0) {
          const hall1 = banquet.lunch.find(item => item.Hall1)?.Hall1 || [];
          const hall2 = banquet.lunch.find(item => item.Hall2)?.Hall2 || [];
          setBanquetLunchHallOne(hall1);
          setBanquetLunchHallTwo(hall2);
        }

        if (banquet.dinner && banquet.dinner.length > 0) {
          const hall1 = banquet.dinner.find(item => item.Hall1)?.Hall1 || [];
          const hall2 = banquet.dinner.find(item => item.Hall2)?.Hall2 || [];
          setBanquetDinnerHallOne(hall1);
          setBanquetDinnerHallTwo(hall2);
        }

        if (inquiry.lunch) {
          setInquiryLunchHallOne(inquiry.lunch.Hall1 || []);
          setInquiryLunchHallTwo(inquiry.lunch.Hall2 || []);
        }

        if (inquiry.dinner) {
          setInquiryDinnerHallOne(inquiry.dinner.Hall1 || []);
          setInquiryDinnerHallTwo(inquiry.dinner.Hall2 || []);
        }

      } catch (error) {
        console.error("Error loading schedule data:", error);
      }
    };

    loadScheduleData();
  }, [token, dateRange, baseUrl]);

  const handlePreviousWeek = () => {
    const newStart = moment(dateRange.start).subtract(7, 'days').format('YYYY-MM-DD');
    const newEnd = moment(newStart).add(6, 'days').format('YYYY-MM-DD');
    setDateRange({ start: newStart, end: newEnd });
    setInitialLoad(false);
  };

  const handleNextWeek = () => {
    const newStart = moment(dateRange.start).add(7, 'days').format('YYYY-MM-DD');
    const newEnd = moment(newStart).add(6, 'days').format('YYYY-MM-DD');
    setDateRange({ start: newStart, end: newEnd });
    setInitialLoad(false);
  };

  const prepareTableData = (banquetData, inquiryData) => {
    return displayDates.map(dateStr => {
      const banquetItems = banquetData.filter(item =>
        moment(item.date).format('dddd, Do MMMM YYYY') === dateStr
      );

      const inquiryItems = inquiryData.filter(item =>
        moment(item.reservation_date).format('dddd, Do MMMM YYYY') === dateStr
      );

      return {
        banquet: banquetItems.length > 0 ? banquetItems[0] : null,
        inquiry: inquiryItems.length > 0 ? inquiryItems : null
      };
    });
  };

  return (
    <div className="">
      <Navbar />
      <div className='arrows'>
        <div className='left-arrow'>
          <BiLeftArrowAlt onClick={handlePreviousWeek} />
        </div>
        <div className='right-arrow'>
          <BiRightArrowAlt onClick={handleNextWeek} />
        </div>
      </div>

      <div className='table-lunch'>
        <p className='lunch'>lunch</p>
        <div className='table-responsive-lunch'>
          <Availability
            type="lunch"
            nepaliHeader={nepaliDates}
            headers={displayDates}
            hallOneData={prepareTableData(banquetLunchHallOne, inquiryLunchHallOne)}
            hallTwoData={prepareTableData(banquetLunchHallTwo, inquiryLunchHallTwo)}
          />
        </div>
      </div>

      <div className='table-dinner'>
        <p className="dinner">dinner</p>
        <div className='table-responsive-lunch'>
          <Availability
            type="dinner"
            nepaliHeader={nepaliDates}
            headers={displayDates}
            hallOneData={prepareTableData(banquetDinnerHallOne, inquiryDinnerHallOne)}
            hallTwoData={prepareTableData(banquetDinnerHallTwo, inquiryDinnerHallTwo)}
          />
        </div>
      </div>
    </div>
  );
};

export default Schedule;